import { useMergeRefs } from '@floating-ui/react';
import { withSubComponent } from '@magnetic/higher-order-components';
import { useClassNames } from '@magnetic/hooks';
import { AnimatePresence, motion } from 'framer-motion';
import React, { forwardRef, useRef, useEffect } from 'react';
import { useNavContext } from '../nav-context.js';
import { NavDrawerContent } from './content.js';
import { useDrawerContext } from './drawer-context.js';
import { NavDrawerItem } from './item.js';
import { NavDrawerItemGroup } from './item-group.js';
import { NavDrawerNavigation } from './navigation.js';
import { useCloseOnEscape } from './use-close-on-escape.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const duration = 0.15;
const ease = [0.6, 0, 0.2, 1];
const useCloseOnClickOutside = /* @__PURE__ */ __name((ref, callback) => {
  useEffect(() => {
    const handleDocumentClick = /* @__PURE__ */ __name((e) => {
      var _a, _b;
      if ((_a = document.querySelector("#mds-left-nav")) == null ? void 0 : _a.contains(e.target)) {
        return;
      }
      if (!((_b = ref == null ? void 0 : ref.current) == null ? void 0 : _b.contains(e.target))) {
        callback();
      }
    }, "handleDocumentClick");
    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, [ref, callback]);
}, "useCloseOnClickOutside");
const subcomponents = {
  Content: NavDrawerContent,
  Item: NavDrawerItem,
  Navigation: NavDrawerNavigation,
  ItemGroup: NavDrawerItemGroup
};
const RenderNavDrawer = /* @__PURE__ */ __name(({ children, className, ...props }, ref) => {
  const { closeDrawer, isDrawerOpen, setOpenId, setOpenLabel } = useNavContext();
  const { floatingStyles, refs } = useDrawerContext();
  const classNames = useClassNames("mds-rebuild-nav-drawer", className);
  const node = useRef(null);
  const mergedRefs = useMergeRefs([node, refs.setFloating, ref]);
  useCloseOnClickOutside(node, () => closeDrawer == null ? void 0 : closeDrawer());
  useCloseOnEscape();
  return /* @__PURE__ */ React.createElement(AnimatePresence, {
    onExitComplete: () => {
      setOpenId == null ? void 0 : setOpenId(void 0);
      setOpenLabel == null ? void 0 : setOpenLabel(void 0);
    }
  }, isDrawerOpen && /* @__PURE__ */ React.createElement(motion.section, {
    ...props,
    animate: { width: "288px" },
    className: classNames,
    exit: { width: 0 },
    initial: { width: 0 },
    key: "modal",
    ref: mergedRefs,
    style: floatingStyles,
    transition: { duration, ease }
  }, children));
}, "RenderNavDrawer");
const NavDrawer = withSubComponent(
  forwardRef(RenderNavDrawer),
  subcomponents
);
NavDrawer.displayName = "Nav.Drawer";

export { NavDrawer };
//# sourceMappingURL=index.js.map
